export const MASTER_DATA_TYPE = Object.freeze({
  JOB_CHARGE: "job_charge",
  JOB_TYPE: "job_type",
  CLIENT_DATA: "client_data",
  PAYMENT_MODE: "payment_mode",
  LEDGER_GROUP: "ledger_group",
  LEDGER: "ledger",
});